/* this file is transformed by vux-loader */
/* eslint-disable */
import _asyncToGenerator from "G:/SVN/\u5B9A\u5236\u9879\u76EE/\u534E\u7535\u5F00\u5173/7_\u6E90\u4EE3\u7801/front/smy-vux-cli3-h5-huadian/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "G:/SVN/\u5B9A\u5236\u9879\u76EE/\u534E\u7535\u5F00\u5173/7_\u6E90\u4EE3\u7801/front/smy-vux-cli3-h5-huadian/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.function.name.js";
//
//
//
//
import '@ungap/global-this';
import imageCompression from 'browser-image-compression';
import upload from '@/utils/upload';
import { getOssSign } from '@/utils/getOssSign';
import { mapState } from 'vuex';
export default {
  name: 'fileupload',
  props: {
    target: {
      type: String
    },
    action: {
      type: String
    },
    accept: {
      type: String,
      default: ''
    },
    capture: {
      type: String
    },
    oss: {
      type: Boolean,
      default: false
    },
    multiple: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      file: null
    };
  },
  computed: _objectSpread({}, mapState('globalStore', ['RUN_ENV'])),
  mounted: function mounted() {
    if (this.capture) {
      this.$refs.input.setAttribute('capture', this.capture);
    }

    if (this.multiple) {
      this.$refs.input.setAttribute('multiple', true);
    }

    if (this.RUN_ENV === 'Android') {
      this.$refs.input.removeAttribute('accept');
    }
  },
  methods: {
    emitter: function emitter(event, data) {
      this.$emit(event, data);
    },
    updateProgress: function updateProgress(oEvent) {
      var vm = this;

      if (oEvent.lengthComputable) {
        var percentComplete = Math.round(oEvent.loaded * 100 / oEvent.total);
        vm.emitter('progress', percentComplete);
      } else {
        // Unable to compute progress information since the total size is unknown
        vm.emitter('progress', false);
      }
    },
    onFileChange: function onFileChange(e) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var vm, files, uploadList, uploadFile;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                vm = _this;

                if (!(!_this.target || _this.target === '')) {
                  _context.next = 5;
                  break;
                }

                console.log('Please provide the target url');
                _context.next = 18;
                break;

              case 5:
                if (!(!_this.action || _this.action === '')) {
                  _context.next = 9;
                  break;
                }

                console.log('Please provide file upload action ( POST / PUT )');
                _context.next = 18;
                break;

              case 9:
                if (!(_this.action !== 'POST' && _this.action !== 'PUT')) {
                  _context.next = 13;
                  break;
                }

                console.log('File upload component only allows POST and PUT Actions');
                _context.next = 18;
                break;

              case 13:
                uploadFile = function _uploadFile(file) {
                  var _this2 = this;

                  return new Promise(function (resolve) {
                    upload({
                      action: _this2.action,
                      target: _this2.target,
                      file: file,
                      filename: file.name,
                      headers: {},
                      onProgress: vm.updateProgress,
                      onStart: function onStart(e) {
                        _this2.emitter('start', e);
                      },
                      onEnd: function onEnd(e) {
                        _this2.emitter('finish', e);

                        resolve(e);
                      }
                    });
                  });
                };

                files = e.target.files || e.dataTransfer.files;

                if (files.length) {
                  _context.next = 17;
                  break;
                }

                return _context.abrupt("return");

              case 17:
                if (_this.multiple) {
                  uploadList = Array.from(files).map(function (file) {
                    return uploadFile.call(_this, file);
                  });
                  Promise.all(uploadList);
                } else {
                  uploadFile.call(_this, files[0]);
                }

              case 18:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    }
  }
};